<template>
  <div :style="[gapStyle]" />
</template>

<script>
import { getTargetUnit } from '../utils'

export default {
  name: 'iain-gap',
  props: {
    bgColor: {
      type: String,
      default: 'transparent ' // 背景透明
    },
    // 高度
    height: {
      type: [String, Number],
      default: 30
    },
    // 与上一个组件的距离
    marginTop: {
      type: [String, Number],
      default: 0
    },
    // 与下一个组件的距离
    marginBottom: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    gapStyle() {
      return {
        backgroundColor: this.bgColor,
        height: getTargetUnit(this.height),
        marginTop: getTargetUnit(this.marginTop),
        marginBottom: getTargetUnit(this.marginBottom)
      }
    }
  }
}
</script>
